import { createClient } from '@supabase/supabase-js'
import { supabaseAnonKey, supabaseUrl } from './supabaseEnv'

/**
 * Supabase client for **auth, realtime, and storage** only.
 * Use `db` from `@/lib/supabase` for `.from` / `.rpc` (routed through Express when `VITE_API_URL` is set).
 */
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
